<template>
	<v-container id="login-container" class="page-root pa-0 ma-0" fluid :style="{backgroundImage:'url('+bkImgSrc+')' }">
		<!-- div class="overlay"></div -->
			
		<v-card  elevation="5" class="login-card">
			          <v-card-title class="my-5">		
						华地集团-百购信息管理系统
			          </v-card-title>
			          <v-card-text>
			           
			            <v-form
			              ref="loginForm"			              
			              lazy-validation			              
			            >
			              <v-text-field
			                append-icon="mdi-account-tie"
			                autocomplete="off"
			                name="login"
			                label=""
			                placeholder="用户名"
			                type="text"
			                required
			                outlined			   
							:rules="[rules.username]"
							validate-on-blur
			                v-model="loginForm.username"
			              />
			              <v-text-field
			                append-icon="mdi-lock"
			                autocomplete="off"
			                name="password"
			                label=""
			                placeholder="密码"
			                type="password"			            
			                required
			                outlined
							:rules="[rules.password]"
			                v-model="loginForm.password"
							validate-on-blur
			                v-on:keyup.enter="login"
			              />
			             
			            </v-form>
			          </v-card-text>
			          <v-card-actions>
			            <v-row class="d-flex d-flex-row mx-2 mb-5">
							<v-btn class="flex-grow-1 flex-shrink-1 pa-6 a-button" text color="primary" outlined  @click="login">
							  登录
							</v-btn>
							<!--
							<v-btn class="flex-grow-0 flex-shrink-0 pa-5 ml-5" text color="primary" outlined  @click="scan">
							  扫码
							</v-btn>
							-->
						</v-row>
			            
			          </v-card-actions>
			        </v-card>
					<div class="beian text-center pt-1">
						<div>
						<span>
							<img :src="batbImgSrc" width="16" height="16" class="mt-1 mr-1"/>
							<a href="https://beian.mps.gov.cn/#/query/webSearch?code=32020502001081" rel="noreferrer" target="_blank">苏公网安备32020502001081</a>

						</span>
						</div>
						<div>
						<span data-v-16d0c568="" class="white--text">
							<span>版权所有 © 江苏华地国际控股集团有限公司</span> 
							<a data-v-16d0c568="" href="http://beian.miit.gov.cn">苏ICP备12029420号</a></span>
						</div>
					</div>
	</v-container>
</template>

<script>
	
	import pic from '../../assets/images/background.jpg';
	import batb from '../../assets/images/batb.png';
	import {default as AuthApi} from "../../api/smp/auth/Auth.js";
	import {default as AuthUtil} from "../../util/auth.js";
	
	export default{
		name:"login",
		data(){
		    return {
		        bkImgSrc:pic,
				batbImgSrc:batb,
				authApi:AuthApi,
				authUtil:AuthUtil,
				loginForm:{
					username:'',
					password:''
				},
				rules:{
					username:function(username){
						if((!username)||(username==''))
							return '';
						return true;
					},
					password:function(password){
						if((!password)||(password==''))
							return '';
						return true;
					}
				}
		    }
		},
		created:function(){
			console.log('login created');
		},
		methods:{
			login:function(){
				let me =this;
				
				if(!(this.$refs.loginForm.validate()))
					return;
				else{
					me.errMsg('错误','用户名或密码错误');
					return;
				}


				me.authApi.login(this.loginForm.username,this.loginForm.password)
				.then(
					function(resp){
						console.log(resp);
						let data = resp.data;
						if((!data)||(!(data.code))||(data.code!=200)){
							let msg=data.msg;
							msg = ((!msg)||(msg==''))?'获取令牌失败':msg;
							me.errMsg('错误',msg);
							return;
						}
						if((!data.data.tokenInfo)||(!data.data.tokenInfo.access_token)||(data.data.tokenInfo.access_token=='')){
							me.errMsg('错误','获取令牌失败(无令牌数据)');
							return;
						}
						let accessToken = data.data.tokenInfo.access_token;
						me.authUtil.setAccessToken(accessToken);
						me.$router.push({path:'/main'});	
					}
				)
				.catch(
					function(resp){
						console.log(resp);
						me.errMsg('错误','获取或缓存令牌信息失败');
					}
				);
			},
			scan:function(){
				
			},
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
		},
		
	}
</script>

<style scoped>
	#login-container{
		position:absolute;
		background-size: cover;
		background-position: 50%;
	}
	
	.page-root{
		width:100%;
		height:100%;
		
	}
	.overlay{
	    display: block;
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    background-color: rgba(255,255,255,0.2);
	    z-index:1;
	    -moz-opacity: 0.2;
	    opacity:.20;
	    filter: alpha(opacity=20);
	}	

	.login-card {
		z-index:10;
		
		position: absolute;
	    top: 50%;
	    left: 50%;
	    
		transform: translate(-50%, -50%);
		width:400px;
	    padding: 30px;
		border-radius: 8px;
		box-shadow: 10px 10px 20px 0px rgba(0, 0, 0, 0.7);
		text-align: center;
		background-color: rgba(220,255,251, 0.5) !important;
	}
	.a-button{
		/*background-color: rgba(190,255,251, 0.2) !important;*/
		background-color: #303F9F !important;

	}

	.copyright{
		height: 30px;
		background-color: #000;
		position: absolute;
		bottom: 30;
		left: 0;
		right: 0;
	}

	.beian{
		height: 60px;
		background-color: #000;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}

</style>
